import { compose } from 'redux';
import { connect } from 'react-redux';
import { withReducer } from '../../withReducer';
import { clickExport } from '../../actionbar/actions';
import { selectMapAttributionKey } from '../mapattribution/selectors';
import { toggleOptional } from '../actions';
import { withSettings } from '../withSettings';
import { MapPreview } from './preview';
import { changeScaleAndCenter, changeMapState, setMinMaxScale } from './actions';
import { reducer } from './reducer';
const mapStateToProps = (state, props) => {
    const mapAttributionKey = selectMapAttributionKey(state);
    const mapAttribution = mapAttributionKey && state[mapAttributionKey];
    return {
        ...state[props.componentIdent],
        isDimensionFixed: state.actionBar.isDimensionFixed,
        mapAttribution: mapAttribution,
        isChecked: !state[props.componentIdent].isHidden,
        format: state.actionBar.format,
    };
};
const mapDispatchToProps = (dispatch, props) => {
    return {
        changeScale: (scale, center) => {
            dispatch(changeScaleAndCenter(scale, center, props.componentIdent));
        },
        changeCenter: (scale, center) => {
            dispatch(changeScaleAndCenter(scale, center, props.componentIdent));
        },
        changeMapState: (mapState) => {
            dispatch(changeMapState(props.componentIdent, mapState));
        },
        setMinMaxScale: (minMaxScale) => {
            dispatch(setMinMaxScale(props.componentIdent, minMaxScale));
        },
        onDimensionFixed: (olMap, format) => {
            dispatch(clickExport(olMap, format));
        },
        onSwitchChange: props.isOptional
            ? (e) => {
                dispatch(toggleOptional(e.target.checked, props.componentIdent));
            }
            : undefined,
    };
};
export const MapContainerPreview = compose(withReducer(reducer), connect(mapStateToProps, mapDispatchToProps))(MapPreview);
export const MapContainerForm = compose(withReducer(reducer), connect(mapStateToProps, mapDispatchToProps))(withSettings());
//# sourceMappingURL=container.js.map